<template>
<div class="UpdateAddElementAction">
   <div class="container-fluid padding-right-0Px padding-left-0px">

      <div class="row vertical-align margin-bottom-2Perc">
        <div class="create-element-overlay-course-title-font-styles font-weight-bold col-md-12 col-lg-12 padding-left-0px padding-right-0Px">
          <u>Define the position of element</u>
        </div>
      </div>

      <div class="row vertical-align margin-bottom-2Perc text-align-left">
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px">
          Lesson
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
          <select class="form-control" v-model="selectedLessonObjValue">
            <option value=-1 disabled>Select</option>
            <option v-for="moduleObj in courseJourneyListValue" v-bind:key="moduleObj.ModuleId" v-bind:value="moduleObj">{{ moduleObj.Title }}</option>
          </select>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px">
          Attached below to
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
          <select class="form-control" v-model="selectedElementObjValue">
            <option value=-1 disabled>Select</option>
            <option v-for="elementObj in getElementListForSelectedLesson" v-bind:key="elementObj.ElementId" v-bind:value="elementObj" v-if="selectedLessonObjValue !== -1">{{ elementObj.Title }}</option>
          </select>
        </div>
      </div>

      <div class="row vertical-align margin-bottom-2Perc text-align-left">
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px">
          Step to attach
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
          <div class="row vertical-align margin-bottom-2Perc text-align-left" v-for="stepObj in personalizedStepList" v-bind:key="stepObj.ElementId" v-bind:value="stepObj">
            <div class="col-md-12 col-lg-12 text-align-left">
              <input type="checkbox" v-model="getAttachedElementIdList" v-bind:value="stepObj.ElementId"> {{stepObj.Title}}
            </div>
          </div>
        </div>
        <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px padding-right-0Px">
          Sequence
        </div>
        <div class="col-md-4 col-lg-4 padding-right-0Px">
          <div class="row vertical-align margin-bottom-2Perc text-align-left" v-for="stepObj in personalizedStepList" v-bind:key="stepObj.ElementId" v-bind:value="stepObj">
            <div class="col-md-12 col-lg-12">
              {{attachedElementIdList.indexOf(stepObj.ElementId) === -1 ? 'Not Included' : (attachedElementIdList.indexOf(stepObj.ElementId) + 1)}}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-5 col-lg-5"></div>  
        <div class="col-md-2 col-lg-2">
          <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateExistingRuleAction">Update</button>
        </div>  
        <div class="col-md-5 col-lg-5"></div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box> 
 </div>
 
</template>

<script>
import AlertBox from '@/components/AlertOverlay'
import { moduleService } from '@/server-util/module-service'
import { constants } from '../../utils/constants'
import { ruleActionService } from '@/server-util/rule-action-service'
import {find, findIndex} from 'lodash'
export default {
  props: ['lessonObj', 'ElementObj', 'selectedEditableRuleActionObj', 'actionList', 'actionObjFromList'],
  created: function () {
    this.getCurrentCourseJourneyScreen()
  },
  data: function () {
    return {
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      selectedLessonObj: -1,
      selectedElementObj: -1,
      courseJourneyList: [],
      personalizedStepList: [],
      attachedElementIdList: [],
      selectedActionRuleObj: null,
      objToReturn: {
        ElementRuleActionId: null,
        RuleId: null,
        ActionId: null,
        ElementId: null,
        RuleParamValues: null,
        ActionMetaData: null
      },
      actionMetaDataObj: {
        ParentModuleId: null,
        ParentElementId: null,
        ElementIds: ''
      }
    }
  },
  name: 'UpdateAddElementAction',
  methods: {
    getCurrentCourseJourneyScreen: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== ''
      ) {
        _this.$store.state.isLoading = true
        moduleService
          .getCourseJourneyDataForAssesment(
            storeObj.state.access_token,
            this.ElementObj.ElementId,
            true
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.courseJourneyList = responseObj.data
              _this.getPersonalizedLessonsContent()
            } else {
              if (_this.$store.state.isLoading === true) {
                _this.$store.state.isLoading = false
              }
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined LOADING ASSESSMENT LIST'
        )
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.selectedLessonObj === -1 || this.selectedLessonObj === undefined || this.selectedLessonObj === 'undefined' || this.selectedLessonObj === null || this.selectedLessonObj === 'null' || this.selectedLessonObj === '') {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a lesson.'
        return false
      } else if (this.selectedElementObj === -1 || this.selectedElementObj === undefined || this.selectedElementObj === 'undefined' || this.selectedElementObj === null || this.selectedElementObj === 'null' || this.selectedElementObj === '') {
        this.showAlertDialog = true
        this.errorMsg = 'Please select any existing element below which you wish to attach new step(s).'
        return false
      } else if (this.attachedElementIdList === undefined || this.attachedElementIdList === null || this.attachedElementIdList.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select atleast one step to attach.'
        return false
      }
      return true
    },
    updateExistingRuleAction: function () {
      var _this = this
      var storeObj = this.$store
      if (this.validateRequiredFieldBeforeSubmit()) {
        if (
          storeObj.state.access_token !== undefined &&
          storeObj.state.access_token !== '' &&
          storeObj.state.access_token !== null
        ) {
          this.objToReturn.ActionMetaData = JSON.stringify(this.actionMetaDataObj)
          console.log('this.objToReturn.ActionMetaData: ' + this.objToReturn.ActionMetaData)
          this.$store.state.isLoading = true
          ruleActionService.updateExistingRuleAction(storeObj.state.access_token, _this.objToReturn).then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                var objToBack = {
                  OperationName: 'Edit',
                  ElementRuleActionId: _this.selectedEditableRuleActionObj.ElementRuleActionId,
                  updatedObj: _this.objToReturn
                }
                _this.$emit('updatedExistingRuleActionList', objToBack)
                console.log('objToBack: ' + objToBack)
                _this.$store.state.isLoading = false
              } else {
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
              }
            },
            errorObj => {
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            }
          )
        } else {
          console.log(
            'ACCESS TOKEN is NULL hence declined DELETE EXISTING RULE AND IT\'S ASSOCIATED ACTION OPERATION'
          )
        }
      }
    },
    getPersonalizedLessonsContent: function () {
      var _this = this
      var storeObj = this.$store
      if (
        storeObj.state.access_token !== undefined &&
        storeObj.state.access_token !== '' &&
        storeObj.state.access_token !== null
      ) {
        this.$store.state.isLoading = true
        ruleActionService.getAllPersonalizationStep(storeObj.state.access_token, _this.getCurrentlySelectedCourseObj.CourseMasterId, _this.selectedEditableRuleActionObj.ElementRuleActionId, true).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it in a local variable
              _this.personalizedStepList = responseObj.data
              _this.setDefaultValues()
              _this.$store.state.isLoading = false
            } else {
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.showAlertDialog = true
              _this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner if its showing to user
            // _this.showSpinner = false
            this.$store.state.isLoading = false
            _this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log(
          'ACCESS TOKEN is NULL hence declined GET RULE LIST OPERATION'
        )
      }
    },
    setDefaultValues: function () {
      this.objToReturn.ElementRuleActionId = this.selectedEditableRuleActionObj.ElementRuleActionId
      this.objToReturn.RuleId = this.selectedEditableRuleActionObj.RuleId
      this.objToReturn.ActionId = this.selectedEditableRuleActionObj.ActionId
      this.objToReturn.ElementId = this.selectedEditableRuleActionObj.ElementId
      console.log('this.selectedEditableRuleActionObj: ' + JSON.stringify(this.selectedEditableRuleActionObj))
      if (typeof this.selectedEditableRuleActionObj.RuleParamValues !== 'string') {
        this.objToReturn.RuleParamValues = JSON.parse(this.selectedEditableRuleActionObj.RuleParamValues)
      } else {
        this.objToReturn.RuleParamValues = JSON.parse(JSON.stringify(this.selectedEditableRuleActionObj.RuleParamValues))
      }
      this.$store.state.personalizationElementListToPost = []
      const actionObj = JSON.parse(this.selectedEditableRuleActionObj.ActionMetaData)
      this.objToReturn.ActionMetaData = actionObj
      if (actionObj !== undefined && actionObj !== 'undefined' && actionObj !== null && actionObj !== 'null' && actionObj !== '') {
        this.actionMetaDataObj.ParentModuleId = actionObj.ParentModuleId
        this.actionMetaDataObj.ParentElementId = actionObj.ParentElementId
        this.actionMetaDataObj.ElementIds = actionObj.ElementIds
        this.attachedElementIdList = actionObj.ElementIds.split(',')
      } else {
        this.actionMetaDataObj.ParentModuleId = ''
        this.actionMetaDataObj.ParentElementId = ''
        this.actionMetaDataObj.ElementIds = ''
        this.attachedElementIdList = []
      }
      var moduleObj = find(this.courseJourneyList, (obj) => {
        return obj.ModuleId === this.actionMetaDataObj.ParentModuleId
      })
      // console.log('moduleObj: ' + JSON.stringify(moduleObj))
      if (moduleObj !== undefined && moduleObj !== 'undefined' && moduleObj !== null && moduleObj !== 'null' && moduleObj !== '') {
        this.selectedLessonObj = moduleObj
        var elementObj = find(moduleObj.ElementObj, (obj) => {
          return obj.ElementId === this.actionMetaDataObj.ParentElementId
        })
        // console.log('elementObj: ' + JSON.stringify(elementObj))
        if (elementObj !== undefined && elementObj !== 'undefined' && elementObj !== null && elementObj !== 'null' && elementObj !== '') {
          this.selectedElementObj = elementObj
        } else {
          this.selectedElementObj = -1
        }
      } else {
        this.selectedLessonObj = -1
        this.selectedElementObj = -1
      }
      this.selectedActionRuleObj = this.actionObjFromList
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    }
  },
  components: {
    'alert-box': AlertBox
  },
  computed: {
    getElementListForSelectedLesson: {
      get: function () {
        if (this.selectedLessonObjValue !== -1) {
          const foundIndex = findIndex(this.selectedLessonObjValue.ElementObj, (elementObj) => {
            return elementObj.ElementId === this.ElementObj.ElementId
          })
          console.log('foundIndex: ' + foundIndex)
          if (foundIndex > -1) {
            var filteredList = []
            for (var i = foundIndex; i < this.selectedLessonObjValue.ElementObj.length; i++) {
              filteredList.push(this.selectedLessonObjValue.ElementObj[i])
            }
            console.log('filteredList.length: ' + filteredList.length)
            return filteredList
          } else {
            return this.selectedLessonObjValue.ElementObj
          }
        } else {
          return []
        }
      }
    },
    courseJourneyListValue: {
      get: function () {
        return this.courseJourneyList
      }
    },
    selectedLessonObjValue: {
      get: function () {
        return this.selectedLessonObj
      },
      set: function (newValue) {
        this.selectedLessonObj = newValue
        this.actionMetaDataObj.ParentModuleId = newValue.ModuleId
        this.actionMetaDataObj.ParentElementId = null
        this.selectedElementObj = -1
      }
    },
    selectedElementObjValue: {
      get: function () {
        return this.selectedElementObj
      },
      set: function (newValue) {
        this.selectedElementObj = newValue
        this.actionMetaDataObj.ParentElementId = this.selectedElementObj.ElementId
        // this.attachedElementIdList = []
        this.actionMetaDataObj.ElementIds = this.attachedElementIdList.length !== 0 ? this.attachedElementIdList.toString() : null
      }
    },
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    getAttachedElementIdList: {
      get: function () {
        return this.attachedElementIdList
      },
      set: function (newValue) {
        this.attachedElementIdList = newValue
        this.actionMetaDataObj.ElementIds = this.attachedElementIdList.length !== 0 ? this.attachedElementIdList.toString() : null
      }
    }
  }
}
</script>

<style scoped>
.font-weight-bold-withOpacity75 {
  font-weight: bold;
  opacity: .75;
}
.cursor-default {
  cursor: default !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.text-align-center {
  text-align: center !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 16px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.border-1px-solid-grey {
  border: 1px solid #aaa;
}
.border-top-1px-solid-grey {
  border-top: 1px solid #dadada;
}
.border-bottom-1px-solid-grey {
  border-bottom: 1px solid #dadada;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.margin-left-1Point6Perc
{
  margin-left:1.6%;
}
.border-red{
  border: 1px solid red; 
}
.padding-left-30px{
  padding-left:30px;
}
.font-size-12px{
  font-size:12px;
}
</style>


// WEBPACK FOOTER //
// src/components/personalization_rule/UpdateAddElementAction.vue